import React from 'react'

function EmptyPageHolder() {
    return (
        <div className='placeholder'>
            <h1>Comming soon ...</h1>
        </div>
    )
}

export default EmptyPageHolder